module.exports = __webpack_public_path__ + "img/RBS04_7.002cb43c.jpg";